import { styled } from '@morf/theming';
import { Container } from '@morf/ui';

export const StyledSchedulingWeek = styled(Container)<{
  isFirstDate: boolean;
  isLastDate: boolean;
  isLoading: boolean;
  isSelectedWeek: boolean;
}>`
  background-color: ${({ theme, isSelectedWeek, isLoading }) =>
    isSelectedWeek && !isLoading
      ? theme.colors.main.primary.darkest
      : theme.colors.ui.card};
  border-radius: ${({ isFirstDate, isLastDate }) =>
    isFirstDate
      ? '1.25rem 0 0 1.25rem'
      : isLastDate
        ? '0 1.25rem 1.25rem 0'
        : 0};
`;
